<template>
  <Label :variant="variant" :size="size" :show-dot="showDot">
    {{ label }}
  </Label>
</template>

<script>
  import { defineComponent, computed, getCurrentInstance } from 'vue';
  import Label from '@/components/partials/Label.vue';

  const VARIANT_MAPS = {
    order: {
      pending: 'default',
      ordered: 'info',
      confirmed: 'success',
      received: 'primary',
      cancelled: 'danger',
      ready_for_installation: 'warning',
      installed: 'success',
      completed: 'success',
    },
    project: {
      draft: 'default',
      planning: 'info',
      active: 'success',
      on_hold: 'warning',
      completed: 'success',
      cancelled: 'danger',
    },
    work_order: {
      pending: 'default',
      scheduled: 'info',
      assigned: 'info',
      ready_for_installation: 'warning',
      open: 'info',
      in_progress: 'purple',
      completed: 'success',
      cancelled: 'danger',
    },
    supplier_mapping: {
      not_mapped: 'warning',
      mapped: 'success',
      partial: 'info',
    },
  };

  const TRANSLATION_KEYS = {
    order: 'orders.statuses',
    project: 'projects.statuses',
    work_order: 'work_orders.statuses',
    supplier_mapping: 'products.supplier_mapping_statuses',
  };

  export default defineComponent({
    name: 'StatusBadge',

    components: { Label },

    props: {
      status: { type: String, required: true },
      type: {
        type: String,
        default: 'order',
        validator: (v) => Object.keys(VARIANT_MAPS).includes(v),
      },
      size: { type: String, default: 'default' },
      showDot: { type: Boolean, default: true },
    },

    setup(props) {
      const instance = getCurrentInstance();
      const $t = instance.appContext.config.globalProperties.$t;

      const variant = computed(() => {
        const map = VARIANT_MAPS[props.type] || {};
        return map[props.status] || 'default';
      });

      const label = computed(() => {
        const key = TRANSLATION_KEYS[props.type];
        return (key && $t(`${key}.${props.status}`)) || props.status;
      });

      return { variant, label };
    },
  });
</script>
